import { render, staticRenderFns } from "./PasoCuatroComponent.vue?vue&type=template&id=2e86ade6"
import script from "./PasoCuatroComponent.vue?vue&type=script&lang=js"
export * from "./PasoCuatroComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports